/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

/** @jsx jsx */

import { jsx } from '@emotion/react'
import { type FunctionComponent } from 'react'

import { EuiTitle } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

import type { BudgetConfigurationValues } from '../../../types'

const chartTitle = {
  organization: {
    id: 'billing.notifications.budget-settings.cost-trends.title.organization',
    defaultMessage: 'Cost Trend - Organization',
  },
  cloud_resource: {
    id: 'billing.notifications.budget-settings.cost-trends.title.cloud-resource',
    defaultMessage: 'Cost Trend - Cloud resource instance',
  },
  default: {
    id: 'billing.notifications.budget-settings.cost-trends.title.default',
    defaultMessage: 'Cost Trend',
  },
}

type Props = {
  scopeType: BudgetConfigurationValues['scopeType']
}

const Title: FunctionComponent<Props> = ({ scopeType }) => (
  <EuiTitle size='xs'>
    <h3>
      <FormattedMessage {...chartTitle[scopeType || 'default']} />
    </h3>
  </EuiTitle>
)

export default Title
